<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="state.modalTitle" width="800px" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="
            () => {
                emit('cancel')
            }
        " :bodyStyle="{ maxHeight: '75vh', overflow: 'auto' }">
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
                <a-form-item label="栏目名称" name="cat_name" required>
                    <a-input placeholder="请输入" v-model:value="formState.cat_name"></a-input>
                </a-form-item>
                <a-form-item label="是否公开" v-if="user.id == 1">
                    <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.is_public"
                        checked-children="公开" un-checked-children="仅自己查看"></a-switch>
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import Ueditor from '@/components/Ueditor/index.vue'
import ls from '@/utils/Storage'
const user = ls.get('USER_INFO')
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {}
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 }
    }
}
interface state {
    modalTitle: string
    loading: boolean
    isEdit: boolean
}
const state = reactive<state>({
    modalTitle: '新增栏目',
    loading: false,
    isEdit: false
})
interface formState {
    cat_name: string
    is_public: number
}
let formState = reactive<formState>({
    cat_name: '',
    is_public: 1
})
onMounted(() => {
    if (props.detailData?.id) {
        state.modalTitle = '编辑【' + props.detailData.cat_name + '】栏目'
        state.isEdit = true
        queryDetail(props.detailData?.id)
    }
})
const queryDetail = (id) => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/newsCat/${id}/edit`,
        method: 'get'
    }
    baseService(requeryParam)
        .then((res) => {
            Object.assign(formState, res.data)
        })
        .finally(() => {
            state.loading = false
        })
}
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            if (props.detailData?.id > 0) {
                let requeryParam = {
                    url: '/admin/v1/newsCat/' + props.detailData.id,
                    method: 'put',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/newsCat',
                    method: 'post',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            }
        })
        .catch(() => { })
}
</script>

<style lang="less" scoped></style>
